var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "occasion-filter" }, [
    _c("div", { staticClass: "title-container", on: { click: _vm.collapse } }, [
      _c("p", { staticClass: "title" }, [
        _vm._v("Occasion "),
        !_vm.selectedOccasion.includes("View All")
          ? _c("span", [
              _vm._v("(" + _vm._s(_vm.selectedOccasion.length) + ")")
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "icon" }, [_vm._v(_vm._s(_vm.plusIcon))])
    ]),
    _vm._v(" "),
    !_vm.collapsed
      ? _c(
          "div",
          { staticClass: "radio-container" },
          _vm._l(_vm.currentOccasions, function(occasion) {
            return _c(
              "div",
              { key: occasion.title, staticClass: "radio-button" },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.selectedOccasion,
                      expression: "selectedOccasion"
                    }
                  ],
                  attrs: { type: "checkbox" },
                  domProps: {
                    value: occasion.title,
                    checked: Array.isArray(_vm.selectedOccasion)
                      ? _vm._i(_vm.selectedOccasion, occasion.title) > -1
                      : _vm.selectedOccasion
                  },
                  on: {
                    change: [
                      function($event) {
                        var $$a = _vm.selectedOccasion,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = occasion.title,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              (_vm.selectedOccasion = $$a.concat([$$v]))
                          } else {
                            $$i > -1 &&
                              (_vm.selectedOccasion = $$a
                                .slice(0, $$i)
                                .concat($$a.slice($$i + 1)))
                          }
                        } else {
                          _vm.selectedOccasion = $$c
                        }
                      },
                      function($event) {
                        return _vm.setSelectedOccasion(occasion.title)
                      }
                    ]
                  }
                }),
                _vm._v(" "),
                _c("p", [_vm._v(_vm._s(occasion.title))])
              ]
            )
          }),
          0
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }